import { getTaxesDiffArrayCore, getArrayNumberChanges } from './chunk-X6IVGVL4.mjs';
import { selectMenu, selectOriginalMenuData, selectChangeDataId, selectIsMenuCreationMode, selectCurrentItem } from './chunk-RO5AAHK3.mjs';
import { getMenuInitialStateForSaving } from './chunk-MBGVVWON.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/menuDifferences/diffSubcategoriesFactory.ts
var SubcategoryMasterFieldLabels = /* @__PURE__ */ ((SubcategoryMasterFieldLabels2) => {
  SubcategoryMasterFieldLabels2[SubcategoryMasterFieldLabels2["name"] = 0] = "name";
  SubcategoryMasterFieldLabels2[SubcategoryMasterFieldLabels2["categoryId"] = 1] = "categoryId";
  return SubcategoryMasterFieldLabels2;
})(SubcategoryMasterFieldLabels || {});
var SubcategoryBasicSectionFieldLabels = /* @__PURE__ */ ((SubcategoryBasicSectionFieldLabels2) => {
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["posName"] = 0] = "posName";
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["active"] = 1] = "active";
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["backgroundColor"] = 2] = "backgroundColor";
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["textColor"] = 3] = "textColor";
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["customizer"] = 4] = "customizer";
  SubcategoryBasicSectionFieldLabels2[SubcategoryBasicSectionFieldLabels2["imageUrl"] = 5] = "imageUrl";
  return SubcategoryBasicSectionFieldLabels2;
})(SubcategoryBasicSectionFieldLabels || {});
var SubcategoryMoreInformationFieldLabels = /* @__PURE__ */ ((SubcategoryMoreInformationFieldLabels2) => {
  SubcategoryMoreInformationFieldLabels2[SubcategoryMoreInformationFieldLabels2["description"] = 0] = "description";
  return SubcategoryMoreInformationFieldLabels2;
})(SubcategoryMoreInformationFieldLabels || {});
var SubcategoryAssociationsFieldLabels = /* @__PURE__ */ ((SubcategoryAssociationsFieldLabels2) => {
  SubcategoryAssociationsFieldLabels2[SubcategoryAssociationsFieldLabels2["itemIds"] = 0] = "itemIds";
  SubcategoryAssociationsFieldLabels2[SubcategoryAssociationsFieldLabels2["comboIds"] = 1] = "comboIds";
  return SubcategoryAssociationsFieldLabels2;
})(SubcategoryAssociationsFieldLabels || {});
var returnLabel = (field) => {
  if (field in SubcategoryMasterFieldLabels) {
    return i18n_config_default.t(
      `app.modals.subcategoriesDiffModal.master.${field}`
    );
  }
  if (field in SubcategoryBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.subcategoriesDiffModal.basic.${field}`
    );
  }
  if (field in SubcategoryMoreInformationFieldLabels) {
    return i18n_config_default.t(
      `app.modals.subcategoriesDiffModal.moreInfo.${field}`
    );
  }
  if (field in SubcategoryAssociationsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.subcategoriesDiffModal.associations.${field}`
    );
  }
};
var diffSubcategoriesFactory = (subcategoryId, diffArray, subcategoriesData, state) => {
  if (diffArray.length > 0) {
    const currentMenu = selectMenu(state);
    const categories = currentMenu.categories;
    const originalData = selectOriginalMenuData(state);
    const formattedDiffArray = diffArray.filter(
      (diff) => diff.path.length === 1 && diff.path[0] !== "itemIds" && diff.path[0] !== "comboIds" && diff.path[0] !== "menuTypeItemIds" && diff.path[0] !== "menuTypeComboIds"
    ).map((diff) => {
      var _a, _b, _c;
      if (!diff.path)
        return { field: null };
      const field = diff.path[((_a = diff.path) == null ? void 0 : _a.length) - 1];
      const value = (_b = diff.rhs) != null ? _b : "";
      let result = {
        field,
        label: (_c = returnLabel(field)) != null ? _c : "",
        value
      };
      if (field === "categoryId") {
        const categoryId = Number(diff.rhs);
        result = __spreadProps(__spreadValues({}, result), {
          id: !categoryId ? null : categoryId,
          value: !categoryId ? i18n_config_default.t(
            "menuScreen.categoryDetails.associations.subcategories.noCategory"
          ) : categories[categoryId].name
        });
      }
      return result;
    });
    const associations = getSubcategoryAssociationsChanges(
      state,
      "subcategories"
    );
    const { masterChanges, basicChanges, moreInformationChanges } = filterChangesBySection(formattedDiffArray);
    return {
      subcategoryId,
      masterChanges,
      basic: basicChanges,
      moreInfo: moreInformationChanges,
      associations,
      taxes: getTaxesDiffArrayCore(
        originalData.taxIds,
        subcategoriesData.taxIds,
        state
      )
    };
  }
  return null;
};
var getMenuTypeElementChanges = (originalMenuTypeElementIds, currentMenuTypeElementIds, elements, menuTypes) => {
  const menuTypeIds = Array.from(
    /* @__PURE__ */ new Set([
      ...Object.keys(originalMenuTypeElementIds),
      ...Object.keys(currentMenuTypeElementIds)
    ])
  );
  const changes = [];
  menuTypeIds.forEach((menuTypeId) => {
    const menuTypeIdNumber = Number(menuTypeId);
    const currentChanges = getArrayNumberChanges(
      originalMenuTypeElementIds[menuTypeIdNumber] || [],
      currentMenuTypeElementIds[menuTypeIdNumber] || []
    ).map(
      (change) => {
        var _a, _b;
        return __spreadProps(__spreadValues({}, change), {
          menuTypeId: menuTypeIdNumber,
          menuTypeValue: ((_a = menuTypes[menuTypeIdNumber]) == null ? void 0 : _a.name) || "",
          value: (_b = elements[change.id]) == null ? void 0 : _b.name
        });
      }
    );
    changes.push(...currentChanges);
  });
  return changes;
};
var getSubcategoryAssociationsChanges = (state, bucket) => {
  const subcategoryId = selectChangeDataId(state);
  const menu = selectMenu(state);
  const isCreation = selectIsMenuCreationMode(state);
  const originalData = isCreation ? getMenuInitialStateForSaving(bucket) : menu[bucket][subcategoryId];
  const currentData = selectCurrentItem(state);
  const menuTypeItemIdsChanges = getMenuTypeElementChanges(
    originalData.menuTypeItemIds,
    currentData.menuTypeItemIds,
    menu.items,
    menu.menuTypes
  );
  const menuTypeComboIdsChanges = getMenuTypeElementChanges(
    originalData.menuTypeComboIds,
    currentData.menuTypeComboIds,
    menu.combos,
    menu.menuTypes
  );
  const changes = [];
  if (menuTypeItemIdsChanges.length > 0) {
    changes.push({
      field: "itemIds",
      label: i18n_config_default.t("menuScreen.common.bucket.items.plural"),
      value: menuTypeItemIdsChanges
    });
  }
  if (menuTypeComboIdsChanges.length > 0) {
    changes.push({
      field: "comboIds",
      label: i18n_config_default.t("menuScreen.common.bucket.combos.plural"),
      value: menuTypeComboIdsChanges
    });
  }
  return changes;
};
var filterChangesBySection = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(SubcategoryMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(SubcategoryBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const moreInformationChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(SubcategoryMoreInformationFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const associationsChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(SubcategoryAssociationsFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    moreInformationChanges,
    associationsChanges
  };
};

export { SubcategoryAssociationsFieldLabels, SubcategoryBasicSectionFieldLabels, SubcategoryMasterFieldLabels, SubcategoryMoreInformationFieldLabels, diffSubcategoriesFactory, getMenuTypeElementChanges, getSubcategoryAssociationsChanges };
